import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipConfig, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { SearchFtthResourcesComponent } from './ftth-resources/search-ftth-resources/search-ftth-resources.component';
import { FtthResourceService } from '../../services/api/ftth-resource/ftth-resource.service';
import { FtthResourceDetailComponent } from './ftth-resources/ftth-resource-detail/ftth-resource-detail.component';
import { SplitterResSpecTableComponent } from './ftth-resources/ftth-resource-detail/splitter-res-spec-table/splitter-res-spec-table.component';
import { SpecTableComponent } from './ftth-resources/ftth-resource-detail/spec-table/spec-table.component';
import { CTOPortResSpecTableComponent } from './ftth-resources/ftth-resource-detail/ctoport-res-spec-table/ctoport-res-spec-table.component';
import { CDPResSpecTableComponent } from './ftth-resources/ftth-resource-detail/cdpres-spec-table/cdpres-spec-table.component';
import { OLTCardResSpecTableComponent } from './ftth-resources/ftth-resource-detail/oltcard-res-spec-table/oltcard-res-spec-table.component';
import { CVLANSpecTableComponent } from './ftth-resources/ftth-resource-detail/cvlanspec-table/cvlanspec-table.component';
import { OLTPortResSpecTableComponent } from './ftth-resources/ftth-resource-detail/oltport-res-spec-table/oltport-res-spec-table.component';
import { ONTResSpecTableComponent } from './ftth-resources/ftth-resource-detail/ontres-spec-table/ontres-spec-table.component';
import { PropertiesWidgetComponent } from './ftth-resources/ftth-resource-detail/properties-widget/properties-widget.component';
import { OLTResWidgetComponent } from './ftth-resources/ftth-resource-detail/oltres-widget/oltres-widget.component';
import { CVLANSpecAsyncTableComponent } from './ftth-resources/ftth-resource-detail/cvlanspec-async-table/cvlanspec-async-table.component';
import { AdministrationTabComponent } from './ftth-resources/ftth-resource-detail/administration-tab/administration-tab.component';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  declarations: [
    SearchFtthResourcesComponent,
    FtthResourceDetailComponent,
    SplitterResSpecTableComponent,
    // @ts-ignore
    SpecTableComponent,
    CTOPortResSpecTableComponent,
    CDPResSpecTableComponent,
    OLTCardResSpecTableComponent,
    CVLANSpecTableComponent,
    OLTPortResSpecTableComponent,
    ONTResSpecTableComponent,
    PropertiesWidgetComponent,
    OLTResWidgetComponent,
    CVLANSpecAsyncTableComponent,
    AdministrationTabComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    NgbTooltipModule,
    PipesModule,
  ],
  providers: [
    FtthResourceService,
    NgbTooltipConfig,
  ],
  exports: [
    CTOPortResSpecTableComponent,
     // @ts-ignore
    SpecTableComponent
  ],
})
export class ResourcesModule {
}
